"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsCreateFingerModal = void 0;
var _DmsModal = require("../../DmsModal/DmsModal");
var _react = _interopRequireWildcard(require("react"));
var _DmsFetch = require("../../DmsFetch/DmsFetch");
var _HttpStatus = require("../../../constants/HttpStatus");
var _DmsButton = require("../../../components/DmsButton/DmsButton");
var _FingerprintRounded = _interopRequireDefault(require("@mui/icons-material/FingerprintRounded"));
var _material = require("@mui/material");
var _TouchApp = _interopRequireDefault(require("@mui/icons-material/TouchApp"));
var _ErrorOutlineOutlined = _interopRequireDefault(require("@mui/icons-material/ErrorOutlineOutlined"));
var _server = require("../../../service/server/server");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsCreateFingerModal = _ref => {
  let {
    selectedRowData,
    modalCreate,
    setShowModalCreate,
    token
  } = _ref;
  const [apiStatus, setApiStatus] = (0, _react.useState)('idle');
  const [apiErrorMsg, setApiErrorMsg] = (0, _react.useState)('');
  const [fingerPrinterTimer, setFingerPrinterTimer] = (0, _react.useState)(false);
  const [resquestUrl, setRequestUrl] = (0, _react.useState)('');
  const [progress, setProgress] = (0, _react.useState)(200);
  const resetStatusModal = async () => {
    setShowModalCreate(false);
    setFingerPrinterTimer(false);
    setProgress(200);
    setApiStatus("idle");
  };
  (0, _react.useEffect)(() => {
    if (fingerPrinterTimer && progress > 0) {
      const timer = setInterval(() => {
        setProgress(prev => {
          if (prev > 1) {
            return prev - 1;
          } else {
            clearInterval(timer);
            setFingerPrinterTimer(false);
            return 0;
          }
        });
      }, 200);
      return () => clearInterval(timer);
    }
  }, [fingerPrinterTimer, progress]);
  const handleRegisterFinger = async () => {
    setApiStatus("inProgress");
    setFingerPrinterTimer(true);
    setRequestUrl((0, _server.getURL)("finger_printer/device/registered_template_by_user_pk/" + selectedRowData.pk));
    const url_register_device = "finger_printer/device/registered_template_by_user_pk/" + selectedRowData.pk;
    const response_device = await (0, _DmsFetch.fetchData)(url_register_device, "POST", token);
    if (response_device.status === _HttpStatus.HTTP_STATUS.OK_200) {
      const url_register_user = "finger_printer/dms";
      const payload = {
        template: response_device.data.data.template,
        user_pk: response_device.data.data.user_pk
      };
      const response_user = await (0, _DmsFetch.fetchData)(url_register_user, "POST", token, payload);
      if (response_user.status === _HttpStatus.HTTP_STATUS.CREATED_201) {
        resetStatusModal();
      } else {
        setApiStatus("error");
        setApiErrorMsg(response_user.data.detail);
        setProgress(200);
        setFingerPrinterTimer(false);
      }
    } else {
      setApiStatus("error");
      setApiErrorMsg(response_device.data.detail);
      setProgress(200);
      setFingerPrinterTimer(false);
    }
  };
  const renderIcon = () => {
    switch (apiStatus) {
      case 'inProgress':
        return /*#__PURE__*/_react.default.createElement(_TouchApp.default, {
          style: {
            fontSize: '4rem',
            color: '#1976d2'
          }
        });
      case 'error':
        return /*#__PURE__*/_react.default.createElement(_ErrorOutlineOutlined.default, {
          style: {
            fontSize: '4rem',
            color: 'red'
          }
        });
      default:
        return /*#__PURE__*/_react.default.createElement(_FingerprintRounded.default, {
          style: {
            fontSize: '4rem',
            color: '#1976d2'
          }
        });
    }
  };
  const renderText = () => {
    switch (apiStatus) {
      case 'error':
        return apiErrorMsg;
      default:
        return "Register finger";
    }
  };
  return /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal, {
    isVisible: modalCreate,
    onClose: () => resetStatusModal(),
    closeWithIconOnly: true
  }, /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Header, {
    title: renderText(),
    onClose: () => resetStatusModal()
  }), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, renderIcon())), /*#__PURE__*/_react.default.createElement(_DmsModal.DmsModal.Footer, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 2,
    width: "100%",
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "primary",
    text: "Register finger",
    onClick: handleRegisterFinger
  })), fingerPrinterTimer && /*#__PURE__*/_react.default.createElement(_material.LinearProgress, {
    variant: "determinate",
    value: progress,
    style: {
      width: '100%',
      height: '8px'
    }
  }))));
};
exports.DmsCreateFingerModal = DmsCreateFingerModal;